import faceboook from "../assets/png/facebook.png";
import telegram from "../assets/png/telegram.png";
import github from "../assets/png/github-sign.png";
import linkIn from "../assets/png/linkedin.png";

const contactme = [
  {
    name: "Name",
    type: "text",
    placeholder: "Your Name",
  },
  {
    name: "Email",
    type: "email",
    placeholder: "Your Email",
  },
  {
    name: "Descriptions",
    type: "textarea",
    placeholder: "Your Message",
  },
];

const contactsocail = [
  {
    logo: faceboook,
    url: "https://www.facebook.com/trelaxz",
  },
  {
    logo: telegram,
    url: "https://t.me/phatreak",
  },
  {
    logo: github,
    url: "https://github.com/TrelaxCoding",
  },
  {
    logo: linkIn,
    url: "https://linkedin.com/in/ry-pheaktra-75118a353",
  },
];
export { contactme, contactsocail };
